"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "bonusListCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $http,
      $filter,
      permissionService,
      settings,
      apiSettings,
      MessageService,
      FileSaver,
      Reports,
      WorkflowApproval,
      BonusRequest,
      Customer,
      list,
      subAreas,
      status,
      solicitants
    ) {
      var vm = this;
      var $translate = $filter("translate");

      vm.subAreas = subAreas;
      vm.status = status;
      vm.solicitants = solicitants;

      // Pagination
      vm.pagination = {
        list: list,
        currentPage: 1,
        pageSize: apiSettings.defaultPageSize,
        pagesTotal: list.total,
      };

      angular.extend($scope.$parent.vm, {
        title: "Bonificações e Patrocínios",
        insertUrl: "main.bonuses",
      });

      $scope.$watch("vm.pagination.currentPage", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          vm.refresh(newValue);
        }
      });

      vm.refresh = function (page) {
        if (vm.customer == null) {
          var customer = null;
        } else {
          var customer = vm.customer.cnpjCpf;
        }

        var params = {
          userName: vm.userName,
          cpfCnpj: customer,
          statusId: vm.statusId,
          bonusesAndSponsorshipsRequestSubAreaId: vm.subAreaId,
          userId: vm.solicitantId,
        };
        params.page = page;
        BonusRequest.list(params).$promise.then(function (data) {
          vm.pagination.list = data;
          vm.pagination.currentPage = data.page;
          vm.pagination.pagesTotal = data.total;
        });
      };

      vm.search = function () {
        vm.refresh(1);
      };

      // AUTOCOMPLETE DE CLIENTES
      vm.getCustomers = function (val) {
        return BonusRequest.customerList({
          /* pageSize: 50, */
          keyword: val,
        }).$promise;
      };
      
      vm.list = [
        {
          id: 1,
          name: "WAL MART BRASIL LTDA",
          date: "24/01/2023",
          value: 10800,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
        {
          id: 2,
          name: "JAYME WAINMAN",
          date: "19/01/2023",
          value: 1500,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
        {
          id: 3,
          name: "WALDIR LACHOWSKI",
          date: "17/01/2023",
          value: 15000,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
        {
          id: 4,
          name: "CENTRAL DE TV EBANO-RADIODIFDE SONS, DADOS E IMAGENS LTDA",
          date: "19/01/2023",
          value: 10000,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
        {
          id: 5,
          name: "MKM ENGENHARIA CONSTRUCOES E COMERCIO LTDA",
          date: "19/01/2023",
          value: 20000,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
        {
          id: 6,
          name: " Paulo	ATHLETIX EMPREENDIMENTOS ESPORTIVOS LTDA",
          date: "16/01/2023",
          value: 5000,
          status: "Iniciada",
          subArea: "Produtos",
          productLine: "N/A",
        },
      ];
    }
  );
